import { Box } from '@mui/material';
import { DefinitionGrid, type DefinitionGridItem } from './DefinitionGrid';
import { designTokens } from '../tokens';
import { detailContentPadding } from './detailLayout';

export type DetailSummaryProps = {
  items: readonly DefinitionGridItem[];
  ariaLabel?: string;
};

/** 상세의 주요 정보를 본문보다 먼저 읽을 수 있도록 묶습니다. 상태는 상세 제목 옆에 둡니다. */
export function DetailSummary({ items, ariaLabel = '주요 정보' }: DetailSummaryProps) {
  return <Box component="section" aria-label={ariaLabel} sx={{
    ...detailContentPadding,
    bgcolor: designTokens.color.overviewSurface,
    borderBottom: `1px solid ${designTokens.color.divider}`,
  }}>
    <DefinitionGrid items={items} emphasizeValues />
  </Box>;
}
